<template>
  <el-dialog
    class="edit-dialog"
    :class="{'fullscreen':fullscreen}"
    :title="dynamicTitle"
    :visible.sync="visible"
    :width="width"
    :before-close="handleBeforeClose"
    :close-on-click-modal="false"
    :fullscreen="fullscreen"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="formRules"
      label-width="100px"
      :size="size"
      v-loading="loading"
      element-loading-text="等待接口数据返回中······"
    >
      <el-form-item
        v-for="col in filteredColumns"
        :key="col.prop"
        :label="col.label"
        :prop="col.prop"
        :rules="col.rules"
      >
        <!-- 文本输入 -->
        <el-input v-if="!col.type || col.type==='text'" v-model="formData[col.prop]" :placeholder="col.placeholder || '请输入'+col.label" />
        <!-- 多行文本 -->
        <el-input v-else-if="col.type==='textarea'" type="textarea" v-model="formData[col.prop]" :placeholder="col.placeholder || '请输入'+col.label" />
        <!-- 数字输入 -->
        <el-input-number v-else-if="col.type==='number'" v-model="formData[col.prop]" :placeholder="col.placeholder || '请输入'+col.label" :min="0" />
        <!-- 下拉选择 -->
        <el-select v-else-if="col.type==='select'" v-model="formData[col.prop]" :placeholder="col.placeholder || '请选择'+col.label">
          <el-option v-for="opt in col.options" :key="getOptionKey(opt)" :label="getOptionLabel(opt)" :value="getOptionValue(opt)" />
        </el-select>
        <el-select v-else-if="col.type==='groupSelect'" v-model="formData[col.prop]" :placeholder="col.placeholder || '请选择'+col.label">
          <el-option-group v-for="group in col.options" :key="group.label" :label="group.label">
            <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
          </el-option-group>
        </el-select>
        <!-- 日期选择 -->
        <el-date-picker v-else-if="col.type==='date'" v-model="formData[col.prop]" type="date" :placeholder="col.placeholder || '请选择'+col.label" />
        <!-- 开关 -->
        <el-switch v-else-if="col.type==='switch'" v-model="formData[col.prop]" :active-value="1" :inactive-value="0" />
        <!-- 单图片上传 -->
        <UploadImage
          v-else-if="col.type==='image'"
          v-model="formData[col.prop]"
          :disabled="loading"
        />
        <!-- 多图片上传 -->
        <UploadImages
          v-else-if="col.type==='images'"
          v-model="formData[col.prop]"
          :disabled="loading"
          :limit="col.limit || 9"
          :max-size="col.maxSize || 1"
        />
        <!-- 文件上传 -->
        <UploadFile
          v-else-if="col.type==='file'"
          v-model="formData[col.prop]"
          :disabled="loading"
          :max-size="col.maxSize || 10"
          :accept-types="col.acceptTypes"
        />
        <!-- 视频上传 -->
        <UploadVideo
          v-else-if="col.type==='video'"
          v-model="formData[col.prop]"
          :disabled="loading"
          :max-size="col.maxSize || 100"
          :accept-types="col.acceptTypes"
        />
        <!-- HTML编辑器 -->
        <div v-else-if="col.type==='html'" class="html-editor-wrapper">
          <el-input
            type="textarea"
            v-model="formData[col.prop]"
            :placeholder="col.placeholder || '请输入HTML内容'"
            :rows="10"
            style="font-family: monospace;"
          />
          <div style="font-size: 12px; color: #999; margin-top: 5px;">
            提示：这是HTML内容编辑区域，支持HTML标签
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import UploadImage from './UploadImage.vue';
import UploadImages from './UploadImages.vue';
import UploadFile from './UploadFile.vue';
import UploadVideo from './UploadVideo.vue';

export default {
  name: 'EditDialog',
  components: {
    UploadImage,
    UploadImages,
    UploadFile,
    UploadVideo
  },
  props: {
    title: { type: String, default: '编辑' },
    width: { type: String, default: '80%' },
    size: { type: String, default: 'medium' },
    api: { type: String, default: '' },
    method: { type: String, default: 'post' },
    fullscreen: { type: Boolean, default: true }
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: {},
      columns: [],
      formRules: {},
      isEdit: false, // 是否为编辑模式
      customApi: null // 自定义API调用函数
    };
  },
  computed: {
    // 根据新增/编辑模式过滤显示的字段
    filteredColumns() {
      return this.columns.filter(col => {
        if (this.isEdit && col.editHide) return false; // 编辑时隐藏
        if (!this.isEdit && col.addHide) return false; // 新增时隐藏
        return true;
      });
    },
    // 动态标题
    dynamicTitle() {
      if (this.title !== '编辑') {
        return this.title; // 如果传入了自定义标题，直接使用
      }
      return this.isEdit ? '编辑' : '新增';
    }
  },
  methods: {
    open(data = {}, columns = [], options = {}) {
      this.visible = true;
      this.columns = columns;
      this.formData = { ...data };
      
      // 根据是否有数据判断是新增还是编辑
      this.isEdit = data && Object.keys(data).length > 0;
      
      // 调试信息
      console.log('EditDialog open:', {
        isEdit: this.isEdit,
        formData: this.formData,
        columns: this.columns.map(col => ({
          label: col.label,
          prop: col.prop,
          type: col.type,
          required: col.required,
          optionsLength: col.options ? col.options.length : 0
        }))
      });
      
      // 自动生成rules
      this.formRules = {};
      columns.forEach(col => {
        if (col.required) {
          this.formRules[col.prop] = [{ required: true, message: `请输入${col.label}`, trigger: 'blur' }];
        }
        if (col.rules) {
          this.formRules[col.prop] = col.rules;
        }
      });
      
      // 支持自定义api/method/customApi
      if (options.api) this.api = options.api;
      if (options.method) this.method = options.method;
      if (options.customApi) this.customApi = options.customApi;
      if (options.title) this.title = options.title;
    },
    
    handleClose() {
      this.visible = false;
    },
    
    handleBeforeClose(done) {
      this.handleClose();
      done();
    },
    
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        try {
          let res;
          
          // 如果有自定义API函数，优先使用
          if (this.customApi && typeof this.customApi === 'function') {
            res = await this.customApi(this.formData);
          } else {
            // 使用传统的API调用方式
            if (this.method === 'post') {
              res = await this.$post(this.api, this.formData);
            } else if (this.method === 'put') {
              res = await this.$put(this.api, this.formData);
            }
          }
          
          this.$message.success('保存成功');
          this.$emit('success', res);
          this.handleClose();
        } catch (e) {
          console.error('保存失败:', e);
          this.$message.error(e.message || '保存失败');
        } finally {
          this.loading = false;
        }
      });
    },

    getOptionKey(opt) {
      return opt.key || opt.id || opt.value || opt.code;
    },

    getOptionLabel(opt) {
      return opt.name || opt.label || opt.title || opt.text;
    },

    getOptionValue(opt) {
      return opt.key || opt.id || opt.value || opt.code;
    }
  }
};
</script>

<style scoped lang="scss">
.edit-dialog{
  :deep(.el-dialog){
    margin:0 auto !important;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .el-dialog__header,.el-dialog__footer{
      flex:none;
      width: 100%;
      box-sizing: border-box;
    }
    .el-dialog__body{
      flex: 1 1 auto;
      overflow-y: auto;
      width: 100%;
      box-sizing: border-box;
    }
  }
  &.fullscreen{
      :deep(.el-dialog){
        height: 100vh;
        width: 100vw;
      }
  }
}
</style> 